import { render } from "./Answer.vue?vue&type=template&id=14f65506&scoped=true"
import script from "./Answer.vue?vue&type=script&lang=js"
export * from "./Answer.vue?vue&type=script&lang=js"

import "./Answer.vue?vue&type=style&index=0&id=14f65506&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f65506"]])

export default __exports__